<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/area_district/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="
        typeof district_list === 'object' &&
        Object.keys(district_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 10%">地区コード</th>
            <th style="width: 40%">名称</th>
            <th style="width: 15%">都道府県</th>
            <th style="width: 15%">地域</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in district_list" :key="list.id">
            <td>{{ list.district_cd }}</td>
            <td>{{ list.label }}</td>
            <td>{{ list.pref_label }}</td>
            <td>{{ list.region_label }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'AreaDistrictListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '地区マスタ一覧',
      fromParentBtn: 'データ登録',
      district_obj: [],
      pref_obj: [],
      region_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    get_pref_data: function () {
      const pref_list = this.pref_list
      return function (pref_cd) {
        return pref_list.find(pref => pref.pref_cd == pref_cd)
      }
    },
    get_pref_label: function () {
      const get_func = this.get_pref_data
      return function (pref_cd) {
        if (get_func(pref_cd)) {
          return get_func(pref_cd).label
        }
        return ''
      }
    },
    get_region_data: function () {
      const region_list = this.region_list
      return function (region_cd) {
        return region_list.find(region => region.region_cd == region_cd)
      }
    },
    get_region_label: function () {
      const get_func = this.get_region_data
      return function (region_cd) {
        if (get_func(region_cd)) {
          return get_func(region_cd).label
        }
        return ''
      }
    },
    district_list: function () {
      const lists = [...this.district_obj]
      return lists
        .map(list => {
          list.pref_label = this.get_pref_label(list.pref_cd)
          list.region_label = this.get_region_label(list.region_cd)
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    pref_list: function () {
      const lists = [...this.pref_obj]
      return lists
        .map(list => {
          list.region_label = this.get_region_label(list.region_cd)
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    region_list: function () {
      const lists = [...this.region_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadRegionList()
    await this.loadPrefList()
    await this.loadDistrictList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '地区マスタです。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.district_obj.find(district => {
          return district.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'area_district' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadDistrictList()
          })
      }
    },
    async loadDistrictList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_district/lists',
        params
      )
        .then(async response => {
          console.log('loadDistrictList response', response)
          this.district_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.district_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/area_district/' + target + '/' })
    }
  }
}
</script>
